import React, { MouseEvent } from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';
import { ArrowLeft, ArrowRight } from 'kb-web-shared';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

interface StepperProps {
  enabled?: boolean;
}

const StepperCommon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 28px;
  height: 28px;
  margin: 1px;
  ${({ enabled }: StepperProps) => `
    background-color: ${enabled ? themes.colors.KBYellow : themes.colors.KBTan};
    :active {
      background-color: ${enabled ? themes.colors.KBNight : themes.colors.KBTan};
    }
  `}
  transition: all 200ms ease 0s;
`;

const LeftStepper = styled(StepperCommon)`
  border-top-left-radius: 14px;
  border-bottom-left-radius: 14px;
`;

const RightStepper = styled(StepperCommon)`
  border-top-right-radius: 14px;
  border-bottom-right-radius: 14px;
`;

type Props = {
  onLeft: (e: MouseEvent) => void;
  onRight: (e: MouseEvent) => void;
  canGoLeft: boolean;
  canGoRight: boolean;
};

const Stepper = (props: Props) => {
  return (
    <Container>
      <LeftStepper enabled={props.canGoLeft} onClick={props.onLeft}>
        <ArrowLeft />
      </LeftStepper>
      <RightStepper enabled={props.canGoRight} onClick={props.onRight}>
        <ArrowRight />
      </RightStepper>
    </Container>
  );
};

export default Stepper;
